import React from 'react';
import { Card } from 'apps/sigma2-ui/src/components/ui/Card';
import { CardStyleProps } from 'apps/sigma2-ui/src/components/ui/CardStyle';

type Props = CardStyleProps & React.ComponentPropsWithoutRef<'section'>;

export const EditRubricCard: React.FC<Props> = ({ ...props }) => {
  return (
    <Card
      as="section"
      className="w-[880px]"
      paddingClassName="p-4"
      roundedClassName="rounded-4xl"
      shadowClassName="shadow-soft"
      {...props}
    />
  );
};
